export { default, links, meta } from "/Users/joel/src/randh/rhremix/app/root.tsx";